export const UPDATE_CONTRACT_DETAIL = 'UPDATE_CONTRACT_DETAIL';

export const CONTRACT_GET_SERVICE_NUMBERS_REQUEST = 'CONTRACT_GET_SERVICE_NUMBERS_REQUEST';
export const CONTRACT_GET_SERVICE_NUMBERS_SUCCESS = 'CONTRACT_GET_SERVICE_NUMBERS_SUCCESS';
export const CONTRACT_GET_SERVICE_NUMBERS_ERROR = 'CONTRACT_GET_SERVICE_NUMBERS_ERROR';

export const CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST =
  'CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_REQUEST';
export const CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS =
  'CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_SUCCESS';
export const CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR =
  'CONTRACT_GET_SERVICE_NUMBERS_FOR_TERMINATE_NUMBER_ERROR';

export const CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST =
  'CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_REQUEST';
export const CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS =
  'CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_SUCCESS';
export const CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR = 'CONTRACT_GET_SERVICE_NUMBERS_FOR_CHANGE_PLAN_ERROR';

export const CONTRACT_GET_PRICE_PLANS_REQUEST = 'CONTRACT_GET_PRICE_PLANS_REQUEST';
export const CONTRACT_GET_PRICE_PLANS_SUCCESS = 'CONTRACT_GET_PRICE_PLANS_SUCCESS';
export const CONTRACT_GET_PRICE_PLANS_ERROR = 'CONTRACT_GET_PRICE_PLANS_ERROR';

export const CONTRACT_GET_ELIGIBILITY_REQUEST = 'CONTRACT_GET_ELIGIBILITY_REQUEST';
export const CONTRACT_GET_ELIGIBILITY_SUCCESS = 'CONTRACT_GET_ELIGIBILITY_SUCCESS';
export const CONTRACT_GET_ELIGIBILITY_ERROR = 'CONTRACT_GET_ELIGIBILITY_ERROR';

export const CONTRACT_GET_EXISTINGVAS_REQUEST = 'CONTRACT_GET_EXISTINGVAS_REQUEST';
export const CONTRACT_GET_EXISTINGVAS_SUCCESS = 'CONTRACT_GET_EXISTINGVAS_SUCCESS';
export const CONTRACT_GET_EXISTINGVAS_ERROR = 'CONTRACT_GET_EXISTINGVAS_ERROR';

export const FILTER_BY_EXPIRY_REQUEST = 'FILTER_BY_EXPIRY_REQUEST';
export const FILTER_BY_EXPIRY_SUCCESS = 'FILTER_BY_EXPIRY_SUCCESS';
export const FILTER_BY_EXPIRY_ERROR = 'FILTER_BY_EXPIRY_ERROR';

export const ADDONS_EXISTINGVAS_REQUEST = 'ADDONS_EXISTINGVAS_REQUEST';
export const ADDONS_EXISTINGVAS_SUCCESS = 'ADDONS_EXISTINGVAS_SUCCESS';
export const ADDONS_EXISTINGVAS_ERROR = 'ADDONS_EXISTINGVAS_ERROR';

export const CONTACT_EXPIRY_REQUEST = 'CONTACT_EXPIRY_REQUEST';
export const CONTACT_EXPIRY_SUCCESS = 'CONTACT_EXPIRY_SUCCESS';
export const CONTACT_EXPIRY_ERROR = 'CONTACT_EXPIRY_ERROR';

export const FILTER_BY_SIM_REQUEST = 'FILTER_BY_SIM_REQUEST';
export const FILTER_BY_SIM_SUCCESS = 'FILTER_BY_SIM_SUCCESS';
export const FILTER_BY_SIM_ERROR = 'FILTER_BY_SIM_ERROR';

export const ACTIVATE_SIM_REQUEST = 'ACTIVATE_SIM_REQUEST';
export const ACTIVATE_SIM_SUCCESS = 'ACTIVATE_SIM_SUCCESS';
export const ACTIVATE_SIM_ERROR = 'ACTIVATE_SIM_ERROR';

export const CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST = 'CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_REQUEST';
export const CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS = 'CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_SUCCESS';
export const CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR = 'CONTRACT_GET_SERVICE_NUMBERS_WITH_NETWORK_ERROR';

export const CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST = 'CEASE_ADDONS_GET_SERVICE_NUMBERS_REQUEST';
export const CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS = 'CEASE_ADDONS_GET_SERVICE_NUMBERS_SUCCESS';
export const CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR = 'CEASE_ADDONS_GET_SERVICE_NUMBERS_ERROR';

export const CEASE_ADDONS_DETAILS_REQUEST = 'CEASE_ADDONS_DETAILS_REQUEST';
export const CEASE_ADDONS_DETAILS_SUCCESS = 'CEASE_ADDONS_DETAILS_SUCCESS';
export const CEASE_ADDONS_DETAILS_FAILURE = 'CEASE_ADDONS_DETAILS_FAILURE';

export const SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST = 'SUSPEND_LINE_GET_SERVICE_NUMBERS_REQUEST';
export const SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS = 'SUSPEND_LINE_GET_SERVICE_NUMBERS_SUCCESS';
export const SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE = 'SUSPEND_LINE_GET_SERVICE_NUMBERS_FAILURE';

export const SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST = 'SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_REQUEST';
export const SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS = 'SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_SUCCESS';
export const SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE = 'SUSPEND_LINE_SERVICE_NUMBERS_ELIGIBILITY_FAILURE';

export const REFIT_LINE_SERVICE_NUMBERS_REQUEST = 'REFIT_LINE_SERVICE_NUMBERS_REQUEST';
export const REFIT_LINE_SERVICE_NUMBERS_SUCCESS = 'REFIT_LINE_SERVICE_NUMBERS_SUCCESS';
export const REFIT_LINE_SERVICE_NUMBERS_ERROR = 'REFIT_LINE_SERVICE_NUMBERS_ERROR';
